import React from 'react';
import { saveCatalogGroup } from '@/services/profile-catalog-groups';
import { LoadingIndicator, NoResultsCard } from '@ygtechnologies/bygr-frontend-component-library';
import { CatalogGroup, ProfileCatalogProduct } from '@/types';
import { Trans } from '@lingui/react/macro';
import { faLink, faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import { Tooltip } from '@/components/Tooltip';
import { Button, ButtonBar, Dropdown } from '@ygtechnologies/rubus-ui';
import { CustomLink } from '@/components/navigation';
import { ProductCard, ProductCardList } from '../products/ProductCard';
import { SimplePriceDisplay } from '../products/PriceDisplay';

type CatalogGroupListItemDetailsProps = {
    group: CatalogGroup;
    setIsLoading: (v: boolean) => void;
    products: ProfileCatalogProduct[] | null;
    onProductsChange: (products: ProfileCatalogProduct[]) => void;
};

export const CatalogGroupListItemDetails: React.FC<CatalogGroupListItemDetailsProps> = ({
    group,
    products,
    onProductsChange,
}) => {
    async function removeProduct(product) {
        const newProducts = products!.filter((x) => x !== product && x.id > 0);

        await saveCatalogGroup(
            group,
            newProducts.map((x) => x.id)
        );
        onProductsChange(newProducts);
    }

    if (!products) {
        return <LoadingIndicator />;
    }
    const containsNonEmptyProduct = products.some((x) => !x.isNone); //group.hasNoneOption; //products.some((p) => p.isNone === false);

    return (
        <div>
            <ProductCardList>
                {products.map((product) => (
                    <ProductCard
                        catalog="profile"
                        key={product.id}
                        product={product}
                        priceElement={<SimplePriceDisplay currencyMode="profile" finalPrice={product.defaultPrice || 0} />}
                        dropdownContent={
                            product.id > 0 ? (
                                <Dropdown.Item icon={faTrashAlt} onClick={(e) => removeProduct(product)}>
                                    <Trans>Remove from group</Trans>
                                </Dropdown.Item>
                            ) : null
                        }
                    />
                ))}
            </ProductCardList>

            {products.length === 0 && (
                <NoResultsCard>
                    <Trans>Group contains no products</Trans>
                </NoResultsCard>
            )}

            <ButtonBar>
                <ButtonBar.Right>
                    <Tooltip
                        content={!containsNonEmptyProduct ? <Trans>Add a product in order to link the group</Trans> : null}>
                        <Button
                            as={CustomLink}
                            disabled={!containsNonEmptyProduct}
                            to={`/catalog/groups/link/${group.id}`}
                            variant="primary"
                            icon={faLink}>
                            <Trans>Link product group to units</Trans>
                        </Button>
                    </Tooltip>
                </ButtonBar.Right>
            </ButtonBar>
        </div>
    );
};
